import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import config from 'config'
import BodymovinSegments from 'components/bodymovin/bodymovin_segments'

import styles from './first_lesson_intro.scss'

const dropExampleAnimation = `${config.www_cdn}assets/media/animations/drop-example.json`
const segments = {
	start: {segment: [0, 9], loop: false},
	end: {segment: [11, 151], loop: false},
}

class FirstLessonIntro extends PureComponent {

	constructor() {
		super()
		this.state = {
			componentStatus: 'init',
		}
		this.listeners = {
			onLoaded: this.startAnimation.bind(this),
			onComplete: this.animationCompleted.bind(this),
		}
	}

	startAnimation() {
		this.setState({
			componentStatus: 'start',
		})
	}

	animationCompleted() {
		if (this.state.componentStatus === 'start') {
			this.timerId = setTimeout(() => {
				this.setState({componentStatus: 'end'})
			}, 1600)
		} else {
			this.props.introCompleted()
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timerId)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<BodymovinSegments
					settings={{
						path: dropExampleAnimation,
						viewBoxSize: '100 0 368 100',
						preserveAspectRatio: 'xMidYMin meet',
					}}
					segments={segments}
					segment={this.state.componentStatus}
					listeners={this.listeners}
				>
					<div styleName='animation'></div>
				</BodymovinSegments>
			</div>
		)
	}
}

FirstLessonIntro.propTypes = {
	introCompleted: PropTypes.func,
}

FirstLessonIntro.defaultProps = {
	introCompleted: () => {},
}

export default CSSModules(FirstLessonIntro, styles, {allowMultiple: true})
